import { getCoreApi } from '@/utility/getCoreApi';

import apiRequest from '../apiRequest';

export const declineBidMatch = async (bidId: number, matchId: number): Promise<void> => {
  const url = `${getCoreApi()}/bids/${bidId}/bid-matches/${matchId}/renter-decline`;
  await apiRequest({ url, method: 'POST' }, true);
};
